import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlertController, NavController } from '@ionic/angular';
import { take } from 'rxjs/operators';
import { ProfileModel } from 'src/app/models/profile.model';
import { DataService } from 'src/app/services/data/data.service';
import { MathService } from 'src/app/services/math/math.service';

@Component({
  selector: 'profile-card',
  templateUrl: './profile-card.component.html',
  styleUrls: ['./profile-card.component.scss'],
})
export class ProfileCardComponent implements OnInit {

  @Input()
  role:string;

  @Input()
  mode:string // edit, view, order, catalog, sale, prepare

  @Input()
  loading:boolean = false;

  _item:ProfileModel = {
    details:{
      shortDetails:{},
      geocoding:{}
    }
  }

  @Output() profileClicked = new EventEmitter<ProfileModel>();


  constructor(private dataService:DataService, private navCtrl:NavController, private alertCtrl:AlertController, private mathService:MathService) {

  }

  ngOnInit(){

  }

  @Input()
  set item(item:ProfileModel){
    if(item.role =='producer' && !item.details){
      this.dataService.getProducerDetails(item.key).pipe(take(1)).subscribe(result=>{
        item.details = result;
        this._item = item;
      })
    }
    else{
      this._item = item;
    }
  };

  edit(item:ProfileModel){
    this.navCtrl.navigateForward('/producer/'+ item.owner.key+'/'+item.role+'/'+item.key+'/edit');
  }

  publish(item:ProfileModel){
    this.changeStatus(item,'published');
  }

  unpublish(item:ProfileModel){
    this.changeStatus(item,'unpublished');
  }

  async changeStatus(item:ProfileModel,status){
    console.log(item);
    item.status = status;
    this.dataService.updateProducerResellerStatus(item);
  } 

  clickItem(item:ProfileModel,zone:string){
    if(this.mode =='edit' && this.role=="reseller"){
      if(zone==='header'){
        if(item.status == 'published'){this.unpublish(item);}
        else { this.publish(item)};        
      }
      else{
        this.edit(item);
      }
    }
    else if(this.mode =='select'){
      console.log('click', item);
      this.profileClicked.emit(item);
    }

  }

  viewProfile(item){
    this.navCtrl.navigateForward('/producer/' + item.key+'/profile');
  }

  viewProducts(item){
    this.navCtrl.navigateForward('/producer/'+ item.key+'/product');
  }
}
